import { CancelToken } from 'axios'

import { portalApi } from '@/axios'

import { Customer } from '@/classes/models'

const defaults = {
  createClassInstance: true
}

export default class CustomerService {
  /**
   * Get customers
   *
   * @param {Context} context
   * @param {TableRequest} parameters
   *
   * @return {Promise}
   */
  static getAll (context, parameters, options) {
    options = Object.assign({}, defaults, options)

    const cancelToken = CancelToken.source()

    let request = portalApi.get(this.endpoint(context), {
      cancelToken: cancelToken.token,
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    request.then(response => {
      if (options.createClassInstance) {
        // Map to Customer
        response.data = response.data.map(customer => new Customer(customer))
      }

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  /**
   * Get a customer.
   *
   * @param {Context} context
   * @param {string} reference
   *
   * @return {Promise}
   */
  static get (context, reference, options) {
    options = Object.assign({}, defaults, options)

    let request = portalApi.get(`${this.endpoint(context)}/${reference}`).then(response => {
      return response.data
    })

    return request.then(response => {
      if (options.createClassInstance) {
      // Map to Customer
        response.data = new Customer(response.data)
      }

      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Create a customer
   *
   * @param {Context} context
   * @param {Object} data
   *
   * @return {Promise}
   */
  static add (context, data, options) {
    options = Object.assign({}, defaults, options)

    return portalApi.post(this.endpoint(context), data).then(response => {
      return response.data
    }).then(response => {
      if (options.createClassInstance) {
        // Map to Customer
        response.data = new Customer(response.data)
      }

      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Update a customer.
   *
   * @param {Context} context
   * @param {string} reference
   * @param {Object} data
   *
   * @return {Promise}
   */
  static update (context, reference, data, options) {
    return portalApi.put(`${this.endpoint(context)}/${reference}`, data)
  }

  /**
   * Delete a customer.
   *
   * @param {Context} context
   * @param {string} reference
   *
   * @return {Promise}
   */
  static delete (context, reference, options) {
    return portalApi.delete(`${this.endpoint(context)}/${reference}`)
  }

  /**
   * Get customer data
   *
   * @param {Context} context
   * @param {string} reference
   *
   * @return {Promise}
   */
  static getCustomerData (context, reference, options) {
    options = Object.assign({}, defaults, options)

    return portalApi.get(`${this.endpoint(context)}/${reference}/data`).then(response => {
      return response.data
    })
  }

  /**
   * Delete customer data record by index
   *
   * @param {Context} context
   * @param {string} reference
   * @param {string} index
   */
  static deleteCustomerData (context, reference, index, options) {
    options = Object.assign({}, defaults, options)

    return portalApi.delete(`${this.endpoint(context)}/${reference}/data/${index}`)
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context) {
    return `${context.endpoint(['business', 'merchant', 'configuration'])}/customers`
  }
}
